import { TaskListForm } from "./TaskListForm";

export function CreateTaskListForm() {
  return <TaskListForm mode="create" />;
}